import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './ShadowBox.module.scss.js';

const { componentTestLabel } = getTestLabels('ShadowBox');
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Box/ShadowBox.tsx)
 */
const ShadowBox = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-shadowbox']), ...otherProps, children: children }));
});
ShadowBox.displayName = 'ShadowBox';

export { ShadowBox };
//# sourceMappingURL=ShadowBox.js.map
